export const DANA_GOLDEN_MINUTE_COMPANIES = 'dana_golden_minute_companies';
export const DANA_GOLDEN_MINUTE_DEBUG_TOOLS = 'dana_golden_minute_debug_tools';
export const DANA_ACTIVITY_EMAIL_CHAT = 'dana_activity_email_chat';
export const FORCEBI = 'forcebi';
